@if (exhibitor?.contact_persons) {
<section class="exhibitorcontactpersons">
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-contactperson">Ansprechpartner</h2>
        <hr />
        <section>
          <planone-contact-person-list
            [contactPersons]="exhibitor?.contact_persons"
            [fairId]="exhibitor?.fair_id"
            [exhibitorId]="exhibitor?.id"
            [exhibitorName]="exhibitor?.name"
            [size]="size"
            [limit]="size === 'phone' ? 3 : 6"
            [contactBaseLink]="'/fairs/' + exhibitor?.fair_id + '/exhibitors/' + exhibitor?.id + '/contact/'"
            [contactClickable]="contactClickable"
            (trackContactClick)="
              trackClick($event.element, $event.linkType, $event.linkText, $event.contactPersonId)
            "></planone-contact-person-list>
        </section>
      </div>
    </div>
  </div>
</section>
}
